<template>
  <div class="input-group">
    <input type="text" class="form-control" v-model="days" /> 
    <div class="input-group-addon">{{ _('d') }}</div>
    <input type="text" class="form-control" v-model="hours" /> 
    <div class="input-group-addon">{{ _('h') }}</div>
    <input type="text" class="form-control" v-model="minutes" /> 
    <div class="input-group-addon">{{ _('min') }}</div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data () {
    return {
      time: null
    }
  },
  computed: {
    days: {
      get () {
        if (!this.time) {
          return ''
        }
        return Math.floor(this.time / 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.time = Math.abs(v) * 24 + (this.hours ? this.hours : 0) + (this.minutes ? this.minutes : 0) / 60
      }
    },
    hours: {
      get () {
        if (!this.time) {
          return ''
        }
        return Math.floor(this.time - this.days * 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.time = this.days * 24 + Math.abs(v) + (this.minutes ? this.minutes : 0) / 60
      }
    },
    minutes: {
      get () {
        if (!this.time) {
          return ''
        }
        return Math.round((this.time - this.days * 24 - this.hours) * 60)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.time = this.days * 24 + (this.hours ? this.hours : 0) + Math.abs(v) / 60
      }
    }
  },
  created() {
    this.time = this.value
  },
  watch: {
    time (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>